import { render, staticRenderFns } from "./DataCardTableRow.vue?vue&type=template&id=1b65a042"
import script from "./DataCardTableRow.vue?vue&type=script&lang=js"
export * from "./DataCardTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports